import React, { useContext, useState } from 'react'
import { useTranslation } from "react-i18next";
import MainAppContext from '../../MainAppContext';

import { Card, Col, Row } from 'react-bootstrap';
import { CommandBarButton, DirectionalHint, OverflowSet, TooltipHost } from '@fluentui/react';
import BoardElementTypeBox from '../../components/Products/sKPI/Board/BoardElementTypeBox';
import BoardCreationBox from '../../components/Products/sKPI/Board/BoardCreationBox';
import BoardElementsBox from '../../components/Products/sKPI/Board/BoardElementsBox';
import StatusBar from '../../components/Common/StatusBar';
import MessageBox from '../../components/Common/Message/MessageBox';

import { useGetBoardById, useGetBoardElementsByBoardId, useGetBoardStructure } from '../../hooks/services/sKPI/useOfBoard';
import { useGetUserPropsKpi } from '../../hooks/services/sPrivilege/useOfPrivilege';
import { useCalculateStatusfly } from '../../hooks/component/sKPI/useOfStatusfly';

import { createBoardStructure, saveBoard } from '../../services/sKPI/board.service';

import { canEditBoardOrGap, isNullOrEmpty, showMessage } from '../../common/Helpers';
import { __AppElementType, __BoardStatus, __MessageTypes, enum__BOARD_TEMPLATE_TYPE } from '../../common/Dictionaries';
import { addListBoardElementDataserie } from '../../services/sKPI/element.service';
import BoardAppContext from '../../BoardAppContext';
import { useSelector } from 'react-redux';
import AuthVerify from '../../components/Templates/Site/AuthVerify';
import { __onGoToBoard, __onGoToBoardV2 } from '../../common/SystemRedirections';

function BoardCreation(props) {
    const { token: currentAuth } = useSelector((state) => state.auth);

    const contextSite = useContext(MainAppContext);
    const { _board: objBoard } = useSelector((state) => state.boardScope);

    const { t } = useTranslation();
    
    const listElementTypes = __AppElementType

    const [queryStringBoardId, setQueryStringBoardId] = useState(props.match.params.boardId !== null && props.match.params.boardId !== undefined && props.match.params.boardId !== "" ? props.match.params.boardId : null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const BoardType = enum__BOARD_TEMPLATE_TYPE.NONE

    const [userPropsKpi, setSetUserProps] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardType, queryStringBoardId, null, contextSite.username, userPropsKpi, setSetUserProps)

    useGetBoardById(queryStringBoardId, objBoard !== undefined ? objBoard.id : 0)

    const [boardElementDataserieUnsavedList, setBoardElementDataserieUnsavedList] = useState([]);
    const [selectedElementTypeCard, setSelectedElementTypeCard] = useState({elementType: null, fireUpdate: false})
    const [boardElements, setBoardElements] = useState(null)
    useGetBoardElementsByBoardId(queryStringBoardId, boardElements, setBoardElements)

    const [statusFly, setStatusFly] = useState({ status:null, fireUpdate: true })
    useCalculateStatusfly(objBoard, boardElements, statusFly, setStatusFly)
    
    const boardContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        },
        boardElementList: {
            value: boardElements,
            set: setBoardElements
        },
        selectedElement: {
            value: selectedElementTypeCard,
            set:  setSelectedElementTypeCard,
        }
    }

    const onFinishBoard = () => {
        objBoard.statusId = 2;
                
        saveBoard(objBoard).then((responseCreation) => {
            if (responseCreation.data.succeeded) {
                const l_itemToSave = [];

                boardElements.forEach(element => {
                    element.l_variables.forEach(variable => {
                        l_itemToSave.push(variable)
                    });
                });

                addListBoardElementDataserie(queryStringBoardId, l_itemToSave).then((responseVariables) => {
                    if (responseVariables.data.succeeded) {
                        createBoardStructure(responseCreation.data.data).then((responseStructure) => {
                            if (responseStructure.data.succeeded) {
                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                            }

                            setStatusFly(prevState => ({
                                fireUpdate: true
                            }));
                        }).catch(() => {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                            
                            setStatusFly(prevState => ({
                                fireUpdate: true
                            }));
                        });
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }

                    setStatusFly(prevState => ({
                        fireUpdate: true
                    }));
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    
                    setStatusFly(prevState => ({
                        fireUpdate: true
                    }));
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    
                setStatusFly(prevState => ({
                    fireUpdate: true
                }));
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            
            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        });
    }

    const onCloseBoard = () => {
        objBoard.statusId = 3;

        saveBoard(objBoard).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

            setStatusFly(prevState => ({
                fireUpdate: true
            }));

        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))

            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        });
    }

    const onReopenBoard = () => {
        objBoard.statusId = 2;

        saveBoard(objBoard).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            
            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            
            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        });
    }

    const onOpenBoard = () => {
        objBoard.statusId = 4;

        saveBoard(objBoard).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            
            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            
            setStatusFly(prevState => ({
                fireUpdate: true
            }));
        });
    }

    const onValidateElements = () => {
        for (let index = 0; index < boardElements.length; index++) {
            const element = boardElements[index];
            
            if (element.l_roles.length > 0 && element.l_variables.length > 0 && !isNullOrEmpty(element.htmlColor)) {
                element._isValidElement = true;
            }
            else {
                element._isValidElement = false;
            }
        }

        boardContextStructure.boardElementList.set(boardElements)
    }

    const onDeleteBoardElement = (boardElementId) => {
        const aux_boardElements = boardElements.filter(boardElement => {
            return boardElement.id !== boardElementId;
        });

        setBoardElements(aux_boardElements);
    }

    const onChangeBoardElementColor = (boardElementId, color) => {
        boardElements.forEach(element => {
            if (element.id === boardElementId) {
                element.htmlColor = color;
            }
        });

        setBoardElements(boardElements);
    }

    const onRenderOverflowButton = (overflowItems) => {
        return (
          <TooltipHost content="More items" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              aria-label="More items"
              styles={{ root: { padding: '10px' }, menuIcon: { fontSize: '16px' } }}
              menuIconProps={{ iconName: 'More' }}
              menuProps={{ items: overflowItems }}
            />
          </TooltipHost>
        );
    };
    const filter = (x) => {
        
        if ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) {          
            if (objBoard !== undefined && objBoard.statusId === undefined && statusFly.status === null) {
                //Todos los botones ocultos.
                return false;
            }
            else {
                if (objBoard !== undefined && objBoard.statusId === 1 && statusFly.status === 2) {
                    //Todos los botones ocultos.
                    return false;
                }
                else {
                    if (objBoard !== undefined && objBoard.statusId === 1 && statusFly.status === 3) {
                        //Todos los botones ocultos.
                        return false;
                    }
                    else {
                        if (objBoard !== undefined && objBoard.statusId === 1 && statusFly.status === 4) {
                            return x.key === "finalize"
                        }
                        else {
                            if (objBoard !== undefined && objBoard.statusId === 2 && statusFly.status === 5) {
                                return x.key === "edit" || x.key === "close"
                            }
                            else {
                                if (objBoard !== undefined && objBoard.statusId === 4 && statusFly.status === 4) {
                                    return x.key === "finalize"
                                }
                                else {
                                    if (objBoard !== undefined && objBoard.statusId === 4 && statusFly.status === 3) {
                                        return x.key === "validate"
                                    }
                                    else {
                                        if (objBoard !== undefined && objBoard.statusId === 1 && statusFly.status === 1) {
                                            return false
                                        }
                                        else {
                                            if (true) {

                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }                
            }
        }
        else {
            return false;
        }
    }
    const onRenderItem = (item) => {
        let styles = null;

        switch (item.key) {
            case "finalize":
                styles = {root: {display: (objBoard.statusId !== 2 && objBoard.statusId !== 3) && statusFly.status === 4 && ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) ? "unset" : "none"}}
                break;
            case "close":
                styles = {root: {display: objBoard.statusId === 2 && statusFly.status === 5 && ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) ? "unset" : "none"}}
                break;
            case "edit":
                styles = {root: {display: objBoard.statusId === 2 && statusFly.status === 5 && ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) ? "unset" : "none"}}
                break; 
            case "reopen":
                styles = {root: {display: objBoard.statusId === 3 && statusFly.status === 5 && ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) ? "unset" : "none"}}
                break; 
            case "validate":
                styles = {root: {display: objBoard.statusId === 1 && statusFly.status === 3 && ((contextSite.securityProps !== null && contextSite.securityProps.isAdmin) || canEditBoardOrGap(userPropsKpi)) ? "unset" : "none"}}
                break; 
            default:
                styles = { root: { padding: '10px' } };
                break;
        }

        return (
            <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
                <CommandBarButton
                role="menuitem"
                text={item.name}
                //styles={styles}
                iconProps={{ iconName: item.icon }}
                onClick={item.onClick}
                />
            </TooltipHost>
        );
    };

    return (<>
        <AuthVerify currentToken={currentAuth} />
        <BoardAppContext.Provider value={ boardContextStructure }>
            {
                (true || (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true)) &&
                <>
                    <Row className="pb-2">
                        <Col>
                            <Card className='book-info-form'>
                                <Card.Body className="book-info-form-body">
                                    <Row>
                                        <Col>
                                            {
                                                statusFly.status &&
                                                <StatusBar statusId={statusFly.status}  statusList={__BoardStatus} statusKeyField="key" statusValueField="value" />
                                            }
                                            {
                                                !statusFly.status &&
                                                <StatusBar statusId={0}  statusList={__BoardStatus} statusKeyField="key" statusValueField="value" />
                                            }
                                        </Col>
                                        <Col className="col-auto pt-4 mt-2">
                                            <OverflowSet
                                                className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                role="menubar"
                                                items={[
                                                    {
                                                        key: 'edit',
                                                        icon: 'Go',
                                                        name: t('data-lang-btn-board'),
                                                        onClick: () => __onGoToBoard(objBoard.id),
                                                    },
                                                    {
                                                        key: 'finalize',
                                                        icon: 'ReceiptCheck',
                                                        name: t('data-lang-btn-finish'),
                                                        title: t('data-lang-sk-msg-onboardfinished'),
                                                        onClick: () => onFinishBoard(),
                                                    },
                                                    {
                                                        key: 'edit',
                                                        icon: 'ProcessMetaTask',
                                                        name: t('data-lang-btn-edit'),
                                                        title: t('data-lang-sk-msg-onboardopen'),
                                                        onClick: () => onOpenBoard(),
                                                    },
                                                    {
                                                        key: 'close',
                                                        icon: 'LogRemove',
                                                        name: t('data-lang-btn-close'),
                                                        title: t('data-lang-sk-msg-onboardclosed'),
                                                        onClick: () => onCloseBoard(),
                                                    },
                                                    {
                                                        key: 'reopen',
                                                        icon: 'FolderOpen',
                                                        name: t('data-lang-btn-open'),
                                                        title: t('data-lang-sk-msg-onboardreopen'),
                                                        onClick: () => onReopenBoard(),
                                                    },
                                                    {
                                                        key: 'validate',
                                                        icon: 'ReceiptCheck',
                                                        name: t('data-lang-btn-validate'),
                                                        title: t('data-lang-sk-msg-validate'),
                                                        onClick: () => onValidateElements(),
                                                    },
                                                ].filter(
                                                    x => filter(x))}
                                                onRenderOverflowButton={onRenderOverflowButton}
                                                onRenderItem={onRenderItem}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div style={{position: "absolute", width: "260px", right: "16px", marginTop: "-6px"}} className='pt-2'>
                                            <MessageBox  
                                                inputParam_Position='absolute'
                                                inputParam_Message={ messageConfig.message }
                                                inputParam_Display={ messageConfig.showMessage }
                                                inputParam_MessageType={ messageConfig.messageType }
                                                inputParam_SetterMessage={ setMessageConfig }
                                            />
                                        </div>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='pe-1'>
                            <BoardCreationBox
                                inputParam_EditMode={objBoard === undefined || (objBoard.statusId !== 2 && objBoard.statusId !== 3)}
                                inputParam_EnableCollapse={false}
                            />
                        </Col>
                        <Col className='ps-1'>
                            {
                                //boardContextStructure.boardElementList.value &&
                                <BoardElementTypeBox
                                    inputParam_EditMode={objBoard === undefined || (objBoard.statusId !== 2 && objBoard.statusId !== 3)}
                                    inputParam_ElementList={ listElementTypes }
                                    inputParam_CardElementNameIsDataLang={ true }
                                    inputParam_BoardId={ parseInt(queryStringBoardId) }
                                    inputParam_ShowSelected={false}
                                    inputParam_ShowFilters={false}
                                    inputParam_SetterBoardElements={setBoardElements}
                                    inputParam_SetterStatusFly={setStatusFly}
                                    inputParam_CheckBoardId={true}
                                    inputParam_BoardElements={boardElements}
                                    inputParam_EnableCollapse={false}
                                    inputParam_BoardType={BoardType}
                                />
                            }
                        </Col>
                    </Row>
                    <Row className='pt-2'>
                        <Col>
                            <BoardElementsBox
                                elementList={ boardElements }
                                editMode={objBoard === undefined || (objBoard.statusId !== 2 && objBoard.statusId !== 3)}
                                boardId={ queryStringBoardId }
                                setterBoardElementDeleted={onDeleteBoardElement}
                                setterBoardElementColor={onChangeBoardElementColor}
                                setterStatusFly={setStatusFly}
                                boardElementDataserieUnsavedList={boardElementDataserieUnsavedList}
                                setBoardElementDataserieUnsavedList={setBoardElementDataserieUnsavedList}
                                setBoardElements={setBoardElements}
                                setStatusFly={setStatusFly}
                            />
                        </Col>
                    </Row>
                </>
            }
            {
                (false && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false)) &&
                <div className="pt-5 mt-4">
                    <MessageBox  
                        inputParam_Message={ t('data-lang-msg-accessdenied') }
                        inputParam_Display={ userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false }
                        inputParam_MessageType={ __MessageTypes.ERROR }
                        inputParam_SetterMessage={ null }
                    />
                </div>
            }
        </BoardAppContext.Provider>
    </>);
}

export default BoardCreation;